import { Injectable } from '@angular/core';
import { initializeApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FirebaseService {
  private app = initializeApp(environment.firebase);
  private db: Firestore = getFirestore(this.app, environment.firebase.dbName ?? 'refhub-standard');

  get firestore(): Firestore {
    return this.db;
  }

  // Qui puoi aggiungere metodi di comodo, ad esempio:
  // async getCollection(path: string) { ... }
}


